<template>
  <div :class="['projectList', { inApp: $root.$data.isApp }]">
    <common-title titleName="精品专题课" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <van-list
      v-if="!noData"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      :offset="60"
      @load="onLoad"
    >
      <div class="content">
        <ProjectCard
          v-for="(item, index) in porjectList"
          :key="index"
          :projectInfo="item"
          :useWhere="3"
          @click.native="goPojectDetial(item)"
        />
      </div>
    </van-list>
    <EmptyData v-else :emptyName="'noProductList'" />
    <Foot />
    <OpenMember ref="member" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import { reqProtrialCourse, reqProtrialAccumulate } from '@/api/home';
import ProjectCard from './components/projectCard.vue';
import OpenMember from './components/openMember.vue';

export default {
  components: {
    CommonTitle,
    ProjectCard,
    EmptyData,
    Foot,
    OpenMember,
  },
  data() {
    return {
      orderParam: {
        pageNum: 1,
        pageSize: 20,
      },
      loading: true, // 当loading为true时，转圈圈
      finished: false, // 数据是否请求结束，结束会先显示- 没有更多了 -
      noData: false, // 如果没有数据，显示暂无数据
      porjectList: [],
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getProtrialCourse();
  },
  computed: {
    ...mapState(['userInfo']),
  },

  mounted() {},
  methods: {
    async getProtrialCourse() {
      const res = await reqProtrialCourse(this.orderParam);
      if (res?.code === 0 && res?.data.data) {
        this.loading = false;
        this.porjectList = this.porjectList.concat(res.data.data);
        // eslint-disable-next-line
        this.orderParam.pageNum++;
        // 如果没有数据，显示暂无数据
        if (this.porjectList.length === 0 && res.data.total === 0) {
          this.noData = true;
        }
        // 如果加载完毕，显示没有更多了
        if (this.porjectList.length >= res.data.total) {
          this.finished = true;
        }
      }
    },
    // 列表加载
    onLoad() {
      if (this.finished) return;
      setTimeout(() => {
        this.getProtrialCourse();
        this.loading = true;
      }, 500);
    },
    async goPojectDetial(item) {
      // 校验是否登录
      if (!this.userInfo?.id) {
        // 区分App和h5
        if (this.$root.$data.isApp) {
          this.$sendToApp('login');
        } else {
          // H5
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/projectCourseList' },
          });
        }
      } else {
        if (item.memberLevel && this.userInfo.level !== 30) {
          this.$refs.member.showPop = true;
          return;
        }
        // 精品专题课列表
        this.$router.push({
          path: '/projectDetail',
          query: {
            projectId: item.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.projectList {
  padding: 124px 36px 100px 36px;
  background: #f9f9f9;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
::v-deep .common-foot {
  position: fixed;
  right: 0;
  left: 0;
}
</style>
